import { queryApiByIdString } from '@/services/http/queryApi';
import downloadTextFileFromDatalake from '@/shared/lib/download/downloadTextFileFromDatalake';

export type CsvTableQueryParams = {
  fileName: string;
  groupName: string;
  queryFileId?: string;
  from?: string;
};

export const csvTableApi = {
  data: ({ fileName, groupName, queryFileId, from }: CsvTableQueryParams) => {
    if (queryFileId) {
      return queryApiByIdString(queryFileId, from);
    }

    return downloadTextFileFromDatalake(fileName, groupName);
  }
};
